module.exports = __webpack_public_path__ + "static/ms3-pattern-examples-50c81a99f93c1d39de22f365377372c6.svg";